import { g as o } from "./global.js";
import { p as r } from "./promise-native-constructor.js";
import { i } from "./is-callable.js";
import { i as e } from "./is-forced.js";
import { i as n } from "./inspect-source.js";
import { w as s } from "./well-known-symbol.js";
import { e as t } from "./engine-is-browser.js";
import { e as m } from "./engine-is-deno.js";
import { e as c } from "./engine-v8-version.js";
r && r.prototype;
var f = s("species"),
  a = !1,
  p = i(o.PromiseRejectionEvent),
  u = {
    CONSTRUCTOR: e("Promise", function () {
      var o = n(r),
        i = o !== String(r);
      if (!i && 66 === c) return !0;
      if (!c || c < 51 || !/native code/.test(o)) {
        var e = new r(function (o) {
            o(1);
          }),
          s = function s(o) {
            o(function () {}, function () {});
          };
        if ((e.constructor = {})[f] = s, !(a = e.then(function () {}) instanceof s)) return !0;
      }
      return !i && (t || m) && !p;
    }),
    REJECTION_EVENT: p,
    SUBCLASSING: a
  };
export { u as p };